import communitiesData from '../data/communities.json';

// Cache for loaded community data
let communityCache: any[] | null = null;

/**
 * Loads all community data
 */
export async function loadAllCommunityData(): Promise<any[]> {
  if (communityCache) {
    return communityCache;
  }
  
  try {
    const communities = (communitiesData as any).communities || [];
    communityCache = communities;
    return communities;
  } catch (error) {
    console.error('Error loading community data:', error);
    return [];
  }
}

/**
 * Loads a single community by ID
 */
export async function loadCommunityData(communityId: string): Promise<any | null> {
  try {
    const allCommunities = await loadAllCommunityData();
    const community = allCommunities.find(c => c.id === communityId);
    return community || null;
  } catch (error) {
    console.error(`Error loading community ${communityId}:`, error);
    return null;
  }
}

/**
 * Gets community options for dropdowns
 */
export async function getCommunityOptions(): Promise<Array<{value: string, label: string}>> {
  try {
    const allCommunities = await loadAllCommunityData();
    return allCommunities.map(community => ({
      value: community.id,
      label: community.name
    }));
  } catch (error) {
    console.error('Error getting community options:', error);
    return [];
  }
}